import { Outlet } from "react-router-dom";
import AdmincmsNavbar from "../../components/admin/AdmincmsNavbar/AdmincmsNavbar.js";
import Adminmasterlayout from "./Adminmasterlayout.js";


const Admincmslayout = () => {
    return (
        <>
            <Adminmasterlayout>
                <AdmincmsNavbar />
                <Outlet />   {/* ✅ Ye bahut important hai */}
            </Adminmasterlayout>
        </>
    );
};

export default Admincmslayout;
